<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button matButton="outlined" mat-dialog-close>{{ data.cancelText }}</button>
  <button matButton="filled" type="submit" class="warn-button" (click)="onConfirm()">
    {{ data.confirmText }}
  </button>
</mat-dialog-actions>
